import { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    padding: '0',
});
